<template>
    <section class="app-page">
        
        <template v-if="userAuthorized">
            <header class="app-page-top" v-if="title">
                <div class="container">
                    <div class="columns is-middle is-spaced is-mobile">
                        <div class="column is-narrow">
                            <div class="app-top-content">
                                <h1 class="title is-1">{{ title }}</h1>
                                <div class="subtitle" v-if="subtitle">{{ subtitle }}</div>
                            </div>
                        </div>
                        <div class="column is-narrow" v-if="$slots.actions">
                            <slot name="actions"></slot>
                        </div>
                    </div>
                </div>
            </header>

            <div class="app-page-body" v-if="$slots.default">
                <div class="container">
                    <slot></slot>
                </div>
            </div>

            <footer class="app-page-footer" v-if="$slots.footer">
                <div class="container">
                    <slot name="footer"></slot>
                </div>
            </footer>    
        </template>
        
        <div class="app-page-body" v-if="!userAuthorized">
            <div class="container">
                <b-message type="is-danger" title="Acesso negado" :closable="false">
                    Você não tem permissão para acessar esta página
                </b-message>
            </div>
        </div>

    </section>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "AppPage",
        props: {
            title: {
                type: String,
                default: null
            },
            subtitle: {
                type: String,
                default: null
            },
            checkUserPermission: {
                type: Boolean,
                default: true
            }
        },
        
        computed: {
            ...mapGetters(['isAdminUser']),
            userAuthorized(){
                if(this.checkUserPermission){
                    return this.isAdminUser;
                }
                
                return true;
            }
        }
        
    }
</script>

<style lang="scss">
    @import '@/styles/config.sass';

    .app-page-top {
        padding: $conf-espaco 0;
        background-color: $grey-lighter;
        border-bottom: 1px solid $grey-light;
    }
    
    .app-page-body{
        padding: $conf-espaco 0;
    }

    .app-page-footer {
        bottom: $conf-espaco-pequeno;
        position: sticky;
        z-index: 2;

        .card {
            border: 1px solid $border;
            border-radius: 5px;
        }
    }

</style>
